const currentPage = 810

export function createTrackConfig() {
  return {
    // 榜单商品点击
    poizon_trade_rank_list_product_click(
      platform: string,
      dataset: { position: number; skuId: number; topId: number }
    ) {
      return {
        current_page: currentPage,
        block_type: 891,
        position: dataset.position,
        sku_id: dataset.skuId,
        poizon_list_id: dataset.topId,
        SK: window.dw.getSk(),
      }
    },
    // 新人专区页 / 活动规则
    poizon_activity_sign_block_click() {
      return {
        current_page: currentPage,
        block_type: 1478,
        SK: window.dw.getSk(),
      }
    },
    // 交易榜单tab点击
    poizon_trade_rank_list_tab_click(
      platform: string,
      dataset: { position: number; tradeTabTitle: string }
    ) {
      return {
        current_page: currentPage,
        block_type: 1500,
        position: dataset.position,
        poizon_trade_tab_title: dataset.tradeTabTitle,
        SK: window.dw.getSk(),
      }
    },
    // 优惠券曝光
    poizon_trade_seller_coupon_exposure(platform: string, dataset: { info: any[] }) {
      return {
        current_page: currentPage,
        block_type: 660,
        poizon_content_info_list: dataset.info,
        SK: window.dw.getSk(),
      }
    },
    // 榜单商品曝光
    poizon_trade_rank_list_product_exposure(platform: string, dataset: { spuList: string }) {
      return {
        current_page: currentPage,
        block_type: 891,
        component_content_info_list: dataset.spuList,
        SK: window.dw.getSk(),
      }
    },
    // banner曝光埋点
    poizon_trade_block_content_exposure(platform: string, dataset: { url: string; block: string }) {
      return {
        current_page: currentPage,
        block_type: +dataset.block,
        jump_content_url: dataset.url,
        SK: window.dw.getSk(),
      }
    },
    // banner点击埋点
    poizon_trade_block_content_click(platform: string, dataset: { url: string; block: string }) {
      return {
        current_page: currentPage,
        block_type: +dataset.block,
        jump_content_url: dataset.url,
        SK: window.dw.getSk(),
      }
    },
  } as any
}
